import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import Icon from "%/dynamic-component-editor/options/icon";
import IconVariant from "%/dynamic-component-editor/options/icon-variant";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import IconColor from "%/dynamic-component-editor/options/icon-color";

export default class IconOptions extends BaseOptionsBundle {

  optionTitle = "Icon";
  static optionClassName = "i-dynamic-icon";
  inspectorToolGroup = "icon";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.ICON_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Icon(undefined, hideFromInspector["icon"] ?? false),
      IconVariant,
      IconSize,
      IconColor,
    ]);
  }
}
